import { EventModel } from './event'

/**
 * @memberOf loavies.models.event
 * @constructor
 */
export class TransactionEventModel extends EventModel {
  /**
   * @param {string} id
   * @param {string} eventType
   * @param {number} sequenceId
   * @param {Date} createdAt
   * @param {string} resourceId
   * @param {string} resourceType
   * @param {Object} [previousValues]
   * @param {loavies.models.event.EventAuditDataModel} auditData
   * @param {string} transactionState
   * @param {boolean} isUserVisibleTransactionState
   * @param {string} providerId
   * @param {string} customerId
   */
  constructor({
    id,
    eventType,
    sequenceId,
    createdAt,
    resourceId,
    resourceType,
    previousValues,
    auditData,
    transactionState,
    isUserVisibleTransactionState,
    providerId,
    customerId,
  }) {
    super({
      id,
      eventType,
      sequenceId,
      createdAt,
      resourceId,
      resourceType,
      previousValues,
      auditData,
    })

    /** @type {string} */
    this.transactionState = transactionState

    /** @type {string} */
    this.providerId = providerId

    /** @type {string} */
    this.customerId = customerId

    /** @type {boolean} */
    this.isUserVisibleTransactionState = isUserVisibleTransactionState
  }
}
